import axios from 'axios'
import { ExpenseResponse } from 'src/models/expenseReport.model'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

/**
 * Single OOPE expense detail read (GET /expenses/:id). Replaces the legacy
 * `getExpense` redux thunk, which hit this endpoint with
 * selectAuthedJsonApiRequestConfig === getRequestConfig(RequestConfig.Default).
 */
export const getExpense = async (
  expenseId: string,
): Promise<ExpenseResponse> => {
  return getResponseData(
    axios.get<ExpenseResponse>(
      `/expenses/${expenseId}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
